import { useSelector, useDispatch } from 'react-redux';
import { useEffect } from 'react';

import { 
    Dialog, 
    DialogContent, 
    DialogTitle, 
    Divider, 
    Typography,
    Stack,
    DialogActions,
    Autocomplete,
    Box,
    TextField
} from '@mui/material';

import DoNotDisturbAltIcon from '@mui/icons-material/DoNotDisturbAlt';
import SaveIcon from '@mui/icons-material/Save';

import Select from "react-select";

import { Controller } from 'react-hook-form';

import { colors } from '../../../utils/colors';

import { selectAllAreasOrganizacionales } from '../../../redux/AreaOrganizacional/AreaOrganizacionalSlice';
import { selectAllEmpleadosList } from '../../../redux/Empleados/EmpleadosSlice';
import { 
    fetchInsertOrUpdate,
    selectEstados, 
    selectMensajeros
} from '../../../redux/ControlMensajeria/ControlMensajerioSlice';

export const InsertOrUpdateModal = ({ openModalRegisterOrUpdate, setOpenModalRegisterOrUpdate, form }) => {

    // ? HOOK-DISPATCH
    const dispatch = useDispatch();

    // * DESESTRUCTURACION DE DATOS.
    const {open = false, controlMensajeria = {}, editEnabled = false} = openModalRegisterOrUpdate;

    // ? HOOK-SELECTOR
    const listAreaOrganizacionales = useSelector(selectAllAreasOrganizacionales);
    const empleados = useSelector(selectAllEmpleadosList);
    const mensajeros = useSelector(selectMensajeros);
    const estados = useSelector(selectEstados);

    // ? HOOK-FORM
    const { 
        control, 
        register, 
        reset,
        formState: { errors },
        handleSubmit,
        setValue
    } = form;

    // * FUNCION PARA GUARDAR DATA.
    const onSubmit = ({ controlMensajeria }) => {   
        dispatch(fetchInsertOrUpdate(controlMensajeria));
    }

    // ? HOOK-EFFECT
    useEffect(() => {
        if(editEnabled){
            
            const data = {
                id: controlMensajeria.id,
                usuarioSolicitante: controlMensajeria.usuarioSolicitanteId,
                areaOrganizacionalId: controlMensajeria.areaOrganizacionalId,
                usuarioMensajero: controlMensajeria.usuarioMensajero,
                extension: controlMensajeria.extension,
                estadoId: controlMensajeria.estadoMensajeria.id,
                motivo: controlMensajeria.motivo,
                departamentosRecepcion: controlMensajeria.departamentosRecepcion.map(x => x.id)
            }

            setValue('controlMensajeria', data);
        }
    }, [editEnabled])
    
    return (
        <Dialog
        PaperProps={{ sx: { width: "40%", height: editEnabled ? "75%" : "60%" } }}
        open={open}
        maxWidth='lg'
        >
                
            <DialogTitle sx={{textTransform: 'uppercase'}} className='text-mem text-center'>{editEnabled ? "EDITAR SOLICITUD" : "REGISTRAR SOLICITUD"}</DialogTitle>
            <Divider sx={{ color: colors.azulMem }} />

            <DialogContent>
                <form
                id='form-registrar-control-mensajeria'
                onSubmit={handleSubmit(onSubmit)}
                >
                    <Stack>
                        <Typography fontSize='12px' fontWeight='bold'>Departamento</Typography>
                        <Controller
                            control={control}
                            name="controlMensajeria.areaOrganizacionalId"
                            rules={{
                                required: "El campo es requerido",
                                validate: value => value !== 0 || 'El campo es requerido',
                            }}
                            render={({ field }) => (
                                <Select
                                id='select-area'
                                isDisabled={editEnabled}
                                classNamePrefix="select"
                                isSearchable={true}
                                placeholder="Seleccionar Área"
                                options={listAreaOrganizacionales}
                                getOptionLabel={(option) => option.nombre}
                                getOptionValue={(option) => option.id}
                                onChange={(e) => field.onChange(e.id)}
                                value={listAreaOrganizacionales.find(x => x.id === field.value)}
                                />
                        )}
                        />

                        <Typography fontSize={14} className="text-danger" hidden={!errors.controlMensajeria?.areaOrganizacionalId?.message}>
                            {errors.controlMensajeria?.areaOrganizacionalId?.message}
                        </Typography>
                    </Stack>

                    <Stack mt={1}>
                        <Typography fontSize='12px' fontWeight='bold'>Departamentos Involucrados</Typography>
                        <Controller
                        name="controlMensajeria.departamentosRecepcion"
                        control={control}
                        defaultValue={[]}
                        rules={{ required: 'Este campo es obligatorio' }} // Validaciones
                        render={({ field }) => (
                            <Autocomplete
                                {...field}
                                id="periodo"
                                multiple
                                disablePortal
                                disableClearable
                                getOptionLabel={(areas) => areas.nombre}
                                options={listAreaOrganizacionales}
                                isOptionEqualToValue={(option, value) => option.id === value}
                                noOptionsText="No encontrado"
                                renderOption={(props, areas) => (
                                    <Box component="option" {...props} key={areas.id} value={areas.id}>
                                        {areas.nombre}
                                    </Box>
                                )}
                                renderInput={(params) => (
                                    <TextField 
                                        {...params} 
                                        label="" 
                                    />
                                )}
                                onChange={(event, newValue) => {
                                    // `newValue` es un array de objetos completos (con `id` y `nombre`)
                                    // Aquí solo guardamos los ids seleccionados
                                    const selectedIds = newValue.map(areas => areas.id);
                                    field.onChange(selectedIds); // Actualiza el valor en el formulario solo con los ids
                                }}
                                value={listAreaOrganizacionales.filter(area => 
                                    field.value.includes(area.id)
                                )}
                            />
                        )}
                        />

                        <Typography fontSize={14} className="text-danger" hidden={!errors.controlMensajeria?.departamentosRecepcion}>
                            {errors?.controlMensajeria?.departamentosRecepcion?.message}
                        </Typography>

                    </Stack>

                    <Stack mt={1}>
                        <Typography fontSize='12px' fontWeight='bold'>Extensión</Typography>
                        <input 
                        disabled={editEnabled}
                        {...register('controlMensajeria.extension', {
                            required: "El campo es requerido"
                        })}
                        className='form-control' 
                        type='number' 
                        />

                        <Typography fontSize={14} className="text-danger" hidden={!errors.controlMensajeria?.extension?.message}>
                            {errors.controlMensajeria?.extension?.message}
                        </Typography>
                    </Stack>

                    <Stack mt={1}>
                        <Typography fontSize='12px' fontWeight='bold'>Empleado</Typography>
                        <Controller
                        control={control}
                        name="controlMensajeria.usuarioSolicitante"
                        rules={{
                            required: "El campo es requerido",
                            validate: value => value !== 0 || 'El campo es requerido',
                        }}
                        render={({ field }) => (
                            <Select
                            id='select-empleado'
                            isDisabled={editEnabled}
                            classNamePrefix="select"
                            isSearchable={true}
                            placeholder="Seleccionar Empleado"
                            options={empleados}
                            getOptionLabel={(option) => option.nombreLabel}
                            getOptionValue={(option) => option.id}
                            onChange={(e) => field.onChange(e.id)}
                            value={empleados.find(x => x.id === field.value)}
                            />
                        )}
                        />

                        <Typography fontSize={14} className="text-danger" hidden={!errors.controlMensajeria?.usuarioSolicitante?.message}>
                            {errors.controlMensajeria?.usuarioSolicitante?.message}
                        </Typography>
                    </Stack>

                    <Stack mt={1}>
                        <Typography fontSize='12px' fontWeight='bold'>Motivo</Typography>
                        <input 
                        {...register('controlMensajeria.motivo', {
                            required: "El campo es requerido"
                        })}
                        className='form-control' 
                        type='text' 
                        />

                        <Typography fontSize={14} className="text-danger" hidden={!errors.controlMensajeria?.motivo?.message}>
                            {errors.controlMensajeria?.motivo?.message}
                        </Typography>
                    </Stack>

                    {
                        editEnabled && (
                            <>
                                <Stack mt={1}>
                                    <Typography fontSize='12px' fontWeight='bold'>Mensajero</Typography>
                                    <Controller
                                    control={control}
                                    name="controlMensajeria.usuarioMensajero"
                                    render={({ field }) => (
                                        <Select
                                        id='select-empleado'
                                        classNamePrefix="select"
                                        isSearchable={true}
                                        placeholder="Seleccionar Mensajero"
                                        options={mensajeros}
                                        getOptionLabel={(option) => option.nombreEmpleado}
                                        getOptionValue={(option) => option.id}
                                        onChange={(e) => field.onChange(e.id)}
                                        value={mensajeros.find(x => x.id === field.value) ?? ""}
                                        />
                                    )}
                                    />

                                    <Typography fontSize={14} className="text-danger" hidden={!errors.controlMensajeria?.usuarioMensajero?.message}>
                                        {errors.controlMensajeria?.usuarioMensajero?.message}
                                    </Typography>
                                </Stack>

                                <Stack mt={1}>
                                    <Typography fontSize='12px' fontWeight='bold'>Observaciones</Typography>
                                    <input 
                                    {...register('controlMensajeria.observaciones')}
                                    className='form-control' 
                                    type='text' 
                                    />

                                    <Typography fontSize={14} className="text-danger" hidden={!errors.controlMensajeria?.observaciones?.message}>
                                        {errors.controlMensajeria?.observaciones?.message}
                                    </Typography>
                                </Stack>

                                <Stack mt={1}>
                                    <Typography fontSize='12px' fontWeight='bold'>Estado</Typography>
                                    <Controller
                                    control={control}
                                    name="controlMensajeria.estadoId"
                                    render={({ field }) => (
                                        <Select
                                        id='select-empleado'
                                        classNamePrefix="select"
                                        isSearchable={true}
                                        placeholder="Seleccionar Estado"
                                        options={estados.filter(x => x.id !== 1)}
                                        getOptionLabel={(option) => option.descripcion}
                                        getOptionValue={(option) => option.id}
                                        onChange={(e) => field.onChange(e.id)}
                                        value={estados.find(x => x.id === field.value && x.id !== 1)}
                                        />
                                    )}
                                    />

                                    <Typography fontSize={14} className="text-danger" hidden={!errors.controlMensajeria?.estadoId?.message}>
                                        {errors.controlMensajeria?.estadoId?.message}
                                    </Typography>
                                </Stack>
                            </>
                        )
                    }

                </form>
            </DialogContent>

            <Divider />
            <DialogActions className='justify-content-center'>
                <button 
                id='btn-cancelar' 
                type='button' 
                className='btn btn-danger'
                onClick={() => {
                    setOpenModalRegisterOrUpdate({open: false, controlMensajeria: {}, editEnabled: false});
                    reset();
                }} 
                >
                    CANCELAR
                    <DoNotDisturbAltIcon sx={{marginTop: -0.5, marginLeft: 0.5}}/>
                </button>

                <button 
                form='form-registrar-control-mensajeria'
                type='submit'
                className='btn btn-primary-mem'
                >
                    GUARDAR
                    <SaveIcon sx={{marginTop: -0.5, marginLeft: 0.5}} />
                </button>

            </DialogActions>
        </Dialog>
    )
}
